// Complete PrimeReact locale bundles. A runtime locale swap REPLACES the whole object (there is
// no deep merge with the built-in defaults, unlike at install time), so both objects must define
// every key. The key sets are kept in sync by src/i18n/__tests__/i18n.test.js.
//
// dateFormat is the SAME in both languages (dd.mm.yy) - see src/i18n/formats.js. Only the day and
// month NAMES differ. Both bundles start the week on Monday (this is a European product).

import { PRIME_DATE_FORMAT } from "../formats";

const pl = {
   startsWith: "Zaczyna się",
   contains: "Zawiera",
   notContains: "Nie zawiera",
   endsWith: "Kończy się",
   equals: "Równa się",
   notEquals: "Nie równa się",
   noFilter: "Brak filtra",
   lt: "Mniej niż",
   lte: "Mniej lub równo",
   gt: "Więcej niż",
   gte: "Więcej lub równo",
   dateIs: "Data jest",
   dateIsNot: "Data nie jest",
   dateBefore: "Data przed",
   dateAfter: "Data po",
   clear: "Wyczyść",
   apply: "Zatwierdź",
   matchAll: "Dopasuj wszystko",
   matchAny: "Dopasuj dowolne",
   addRule: "Dodaj zasadę",
   removeRule: "Usuń zasadę",
   accept: "Tak",
   reject: "Nie",
   choose: "Wybierz",
   upload: "Wgraj",
   cancel: "Anuluj",
   firstDayOfWeek: 1,
   dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
   dayNamesShort: ["Ndz", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"],
   dayNamesMin: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "Sb"],
   monthNames: [
      "Styczeń",
      "Luty",
      "Marzec",
      "Kwiecień",
      "Maj",
      "Czerwiec",
      "Lipiec",
      "Sierpień",
      "Wrzesień",
      "Październik",
      "Listopad",
      "Grudzień"
   ],
   monthNamesShort: [
      "Sty",
      "Lut",
      "Mar",
      "Kwi",
      "Maj",
      "Cze",
      "Lip",
      "Sie",
      "Wrz",
      "Paź",
      "Lis",
      "Gru"
   ],
   today: "Dzisiaj",
   dateFormat: PRIME_DATE_FORMAT,
   weekHeader: "Tydz",
   weak: "Słaby",
   medium: "Średni",
   strong: "Mocny",
   passwordPrompt: "Wprowadź hasło",
   emptyFilterMessage: "Brak wyników",
   emptyMessage: "Brak możliwych opcji"
};

const en = {
   startsWith: "Starts with",
   contains: "Contains",
   notContains: "Not contains",
   endsWith: "Ends with",
   equals: "Equals",
   notEquals: "Not equals",
   noFilter: "No filter",
   lt: "Less than",
   lte: "Less than or equal to",
   gt: "Greater than",
   gte: "Greater than or equal to",
   dateIs: "Date is",
   dateIsNot: "Date is not",
   dateBefore: "Date is before",
   dateAfter: "Date is after",
   clear: "Clear",
   apply: "Apply",
   matchAll: "Match all",
   matchAny: "Match any",
   addRule: "Add rule",
   removeRule: "Remove rule",
   accept: "Yes",
   reject: "No",
   choose: "Choose",
   upload: "Upload",
   cancel: "Cancel",
   firstDayOfWeek: 1,
   dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
   dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
   dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
   monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
   ],
   monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
   ],
   today: "Today",
   dateFormat: PRIME_DATE_FORMAT,
   weekHeader: "Wk",
   weak: "Weak",
   medium: "Medium",
   strong: "Strong",
   passwordPrompt: "Enter a password",
   emptyFilterMessage: "No results found",
   emptyMessage: "No available options"
};

export const primeLocales = { pl, en };

export default primeLocales;
